import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from '@mui/material'
import { Description } from '@mui/icons-material'
import { Form, Formik } from 'formik'
import { inject } from 'mobx-react'
import React from 'react'
import FullWidthField from 'src/common/FullWidthField'
import ResponsiveAppBar from 'src/common/ResponsiveAppBar'
import { ISchedule } from 'src/Definitions'
import { DocumentType } from 'src/models/enums/DocumentType.enum'
import { createAuthorizationLog } from 'src/services/AuthorizationLogService'
import { IStores } from 'src/Stores'
import { AuthorizationLogDTO } from 'src/viewModels/AuthorizationLogDTO'
import * as Yup from 'yup'

interface IPTNoteModalProps {
  close?: () => void
  isLoading?: boolean
  isOpen?: boolean
  schedule?: ISchedule
}

class PTNoteModal extends React.Component<IPTNoteModalProps> {
  public state = {
    loadingPdf: false,
  }

  private formRef = React.createRef<any>()

  private close = () => {
    this.props.close!()
  }

  private save = () => {
    const formikValues = this.formRef.current?.values

    const returned = new AuthorizationLogDTO(
      '',
      this.props.schedule!.id,
      DocumentType.PTNote
    )

    returned.ptNote = formikValues.ptNote

    this.setState({ loadingPdf: true })

    createAuthorizationLog(returned, false).finally(() => {
      this.formRef.current?.setSubmitting(false)
      this.setState({ loadingPdf: false })
      this.close()
    })
  }

  public render() {
    const { isOpen } = this.props

    const schema = Yup.object().shape({
      ptNote: Yup.string().required('PT Note is required'),
    })

    return (
      <Dialog open={isOpen ?? false} fullWidth maxWidth="sm">
        {this.state.loadingPdf && (
          <div
            style={{
              position: 'fixed',
              display: 'flex',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              cursor: 'pointer',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1300,
            }}
          >
            <CircularProgress size={100} />
          </div>
        )}
        <Formik
          initialValues={{ ptNote: '' }}
          onSubmit={() => {}}
          validationSchema={schema}
          innerRef={this.formRef}
        >
          {({ isValid }) => (
            <Form id="ptNoteModalForm">
              <DialogTitle style={{ padding: 0 }}>
                <ResponsiveAppBar
                  title="PT Note"
                  pageIcon={<Description />}
                  isModal={true}
                />
              </DialogTitle>
              <DialogContent>
                <Grid container spacing={2} style={{ marginTop: '10px' }}>
                  <Grid item xs={12}>
                    <FullWidthField
                      variant="outlined"
                      name="ptNote"
                      label="PT Note"
                      fullWidth
                      rows={9}
                      multiline
                      required
                      placeholder="Enter PT note..."
                      autoFocus
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.close} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={this.save}
                  color="secondary"
                  variant="contained"
                  disabled={!isValid}
                >
                  Submit PT Note
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    )
  }
}

const InjectedPTNoteModal = inject<
  IStores,
  IPTNoteModalProps,
  Partial<IPTNoteModalProps>,
  any
>((stores: IStores) => ({
  close: stores.schedules.closePTNoteModal,
  isLoading: stores.schedules.isLoading,
  isOpen: stores.schedules.isPTNoteModalOpen,
  schedule: stores.schedules.selectedSchedule,
}))(PTNoteModal)

export default InjectedPTNoteModal
